import { render, staticRenderFns } from "./coderOutpatientList.vue?vue&type=template&id=b1a188c6&scoped=true&"
import script from "./coderOutpatientList.vue?vue&type=script&lang=js&"
export * from "./coderOutpatientList.vue?vue&type=script&lang=js&"
import style0 from "./coderOutpatientList.vue?vue&type=style&index=0&id=b1a188c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a188c6",
  null
  
)

export default component.exports